App.namespace.wrap('es6.shared.google_places_manager', function (options) {
  const API_KEY = window.GOOGLE_MAPS_API_KEY;
  const API_URL = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places,marker&language=en`;
  const COUNTRY_RESTRICTION = window.__TGV_ISO_COUNTRY_CODE || 'GB';

  const inputId = (options && options.inputId) ? options.inputId : 'pac-input';

  const initGoogleMaps = () => {
    $.getScript(API_URL)
      .done(initAutocomplete);
  };

  const initAutocomplete = () => {
    const locationInput = document.getElementById(inputId);
    if (!locationInput) {
      return false;
    }
    const autocomplete = new google.maps.places.Autocomplete(locationInput, {
      types: ['geocode'],
      fields: ['geometry'],
      componentRestrictions: {
        country: COUNTRY_RESTRICTION,
      },
    });

    enableEnterInAutocomplete(locationInput);

    autocomplete.addListener('place_changed', function () {
      if (typeof autocomplete.getPlace().geometry !== "undefined") {
        const bounds = autocomplete.getPlace().geometry.viewport.toJSON()

        $('input[name=longitude_from]').val(bounds.west);
        $('input[name=longitude_to]').val(bounds.east);
        $('input[name=latitude_from]').val(bounds.south);
        $('input[name=latitude_to]').val(bounds.north);

        if(options && options.changeCallback && typeof options.changeCallback === 'function') {
          options.changeCallback();
        }
      }
    });
  };

  const enableEnterInAutocomplete = (input) => {
    (function pacSelectFirst(input) {
      if (!input) {
        return false;
      }

      // store the original event binding function
      const _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

      function addEventListenerWrapper(type, listener) {
        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
        // and then trigger the original listener.
        if (type == "keydown") {
          const orig_listener = listener;
          listener = function (event) {
            const suggestion_selected = $(".pac-item-selected").length > 0;
            if (event.which == 13) {
              event.stopPropagation();
              event.preventDefault();
              if (!suggestion_selected) {
                const simulated_downarrow = $.Event("keydown", {
                  keyCode: 40,
                  which: 40
                });
                orig_listener.apply(input, [simulated_downarrow]);
              }
            }
            orig_listener.apply(input, [event]);
          };
        }
        _addEventListener.apply(input, [type, listener]);
      }

      input.addEventListener = addEventListenerWrapper;
      input.attachEvent = addEventListenerWrapper;
    })(input);
  };

  const init = () => {
    if (options && options.getGoogleApi) {
      initGoogleMaps();
    } else {
      initAutocomplete();
    }
  };

  return {
    init,
  };
});
